export default "__VITE_ASSET__Cw5K0B8M__";